import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, Tooltip } from "@mui/material";
import { blue, green, red } from "@mui/material/colors";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  EventAvailable as EventAvailableIcon,
  EventBusy as EventBusyIcon
} from "@mui/icons-material";
import { ModalV2 } from "../../components/Modal/ModalV2";
import RegularButton from "../../components/CustomButtons/Button";
import { useToggle } from "../../hooks/useToggle";
import { TAXIS_STATES } from "../../helpers/dictionary";
import { deleteNfcTag } from "../../redux/actions/nfcTags/nfcTagsAction";
import { config } from "./config";
import { NfcTagForm } from "./NfcTagForm";

const color = 500;
const color2 = 300;

const { UUID, NIP, BRAND, STATUS, ACTIONS } = config;

export const columns = [
  {
    Header: UUID.header,
    accessor: UUID.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[UUID.key] && row[UUID.key].toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: NIP.header,
    Cell: () => <div>* * * *</div>,
  },
  {
    Header: BRAND.header,
    accessor: BRAND.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[BRAND.key] && row[BRAND.key].toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: STATUS.header,
    accessor: STATUS.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[STATUS.key] && row[STATUS.key].toLowerCase().includes(filter.value.toLowerCase()),
    Cell: ({ original }) =>
      original.status === TAXIS_STATES.FREE.name ? (
        <Tooltip title="Libre">
          <EventAvailableIcon sx={{ color: green[color2] }} />
        </Tooltip>
      ) : (
        <Tooltip title="Ocupado">
          <EventBusyIcon sx={{ color: red[color2] }} />
        </Tooltip>
      ),
  },
  {
    Header: "Acciones",
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const [open, setOpen] = useToggle();
      const [deleteTag, setDeleteTag] = useToggle();
      const { isLoadingComp } = useSelector(({ search }) => search);

      const handleDelete = () => {
        dispatch(deleteNfcTag(original.id, setDeleteTag));
      };

      return (
        <>
          <ButtonGroup
            variant="outlined"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <RegularButton
              justIcon
              round
              color="transparent"
              tooltip="Editar NFC Tag"
              onClick={setOpen}
            >
              <EditIcon style={{ color: blue[color] }} />
            </RegularButton>
            <RegularButton
              justIcon
              round
              color="transparent"
              tooltip="Eliminar NFC Tag"
              onClick={setDeleteTag}
              disabled={original.status !== TAXIS_STATES.FREE.name}
            >
              <DeleteIcon style={{ color: red[color] }} />
            </RegularButton>
          </ButtonGroup>
          <ModalV2
            title="Editar NFC Tag"
            open={open}
            onClose={setOpen}
            toRight
            loading={isLoadingComp?.loadingNfcTagActions}
          >
            <NfcTagForm onClose={setOpen} isEdit tag={original} />
          </ModalV2>
          <ModalV2
            title={`Eliminar NFC Tag ${original.uuidTag} - ${original.brand}`}
            open={deleteTag}
            onClose={setDeleteTag}
            justConfirm
            onSubmit={handleDelete}
          />
        </>
      );
    },
  },
];

export const tagsColumnsAdded = (remove) => {
  return [
    {
      Header: UUID.header,
      accessor: UUID.key,
    },
    {
      Header: BRAND.header,
      accessor: BRAND.key,
    },
    {
      Header: ACTIONS.header,
      Cell: ({ original }) => (
        <RegularButton
          round
          justIcon
          color="transparent"
          onClick={() => remove(original.uuidTag)}
        >
          <DeleteIcon style={{ color: red[color] }} />
        </RegularButton>
      ),
    },
  ];
};
